import EditOutlet from "@/apsales/Outlets/Edit";

export default function AddOutlet() {
    return <EditOutlet mode="add" />;
}